module.exports = __webpack_public_path__ + "static/media/CAMRA-Roundel-Black-20191.1131741f.png";